var React = require('react');
var createReactClass = require('create-react-class');

var Post = createReactClass({

    render() {
        var resourceLabel = '';
        if (this.props.resource_type == '23') {
            resourceLabel = 'Guide';
        }
        else if (this.props.resource_type == '25') {
            resourceLabel = 'Declaration';
        }
        else if (this.props.resource_type == '27') {
            resourceLabel = 'Other';
        }
        
        
        return (

            <div className="col-md-6 col-lg-3">
                <article className="article excerpt d-flex flex-column justify-content-between">
                  <div>
                    <div className="date small" dangerouslySetInnerHTML={ this.createMarkup( this.props.date ) } />

                    <a href={ this.props.link } className="article--excerpt--link">
                      <header className="article--header">
                        <h3 className="article--title" dangerouslySetInnerHTML={ this.createMarkup( this.props.title ) } />
                      </header>      
                    </a>

                    { this.props.posttype === 'update' ?
                      <div className="article--excerpt">        
                        <div className="article--content" dangerouslySetInnerHTML={ this.createMarkup( this.props.content ) } />                        
                      </div>
                    :null
                    }
                  </div>

                  { this.props.posttype === 'update' ?
                    <div>
                      <div className="article--categories">
                        <em className={ "fa fa-calendar-alt type-" + this.props.type } aria-hidden="true"></em>
                      </div>
                    </div>
                  : 
                    <div className="article--categories">
                      <span className="small categories">{ resourceLabel }</span>
                    </div>
                  }

                </article>
                

            </div>
        );

    },

    createMarkup : function( html ) {
        return { __html: html };
    }


});


export default Post;